import React from "react"

import {FieldInlineEditableProps} from "../../../render/inline-editable"
import FieldNumber_InlineEditableComponent from "../components/inline-edit/number-inline-editable"

export default function FieldNumber_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    return <FieldNumber_InlineEditableComponent {...props}
                                                value       = {value}/>

}
